<template>
  <v-tooltip :disabled="hiddenTooltip" bottom>
    <template v-slot:activator="{ on }">
      <button
        v-on="on"
        :disabled="disabled"
        :class="[
          'dr-button-spilka-ui-kit dr-button-spilka-ui-kit-black',
          { 'dr-button-spilka-ui-kit-text': text },
          { 'dr-button-spilka-ui-kit-border': outlined },
          { 'is-disabled': disabled },
        ]"
        style="--btn-color: #000000"
        @click="onClickAction(); showMenu($event)"
      >
        <div class="dr-button-spilka-ui-kit-content">
          <v-icon v-if="iconName" :color="iconColor">{{ iconName }}</v-icon>
          <span>
            {{ caption }}
          </span>
        </div>
      </button>
      </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
  
</template>

<script>
import '../../tools/style/dr-button-spilka-ui-kit.scss'

export default {
  props: {
    iconName: {
      type: String,
      required: false,
      default: ''
    },
    color: {
      type: String,
      required: false,
      default: 'white'
    },
    text: {
      type: Boolean,
      required: false,
      default: false
    },
    caption: {
      type: String,
      required: false,
      default: 'Caption'
    },
    disabled: {
      type: Boolean,
      required: true
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    hiddenTooltip: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    iconColor() {
      if (this.text || this.outlined) {
        return 'black'
      }

      return 'white'
    }
  },
  methods: {
    // Открыть popupMenu
    showMenu(event) {
      this.$emit('showMenu', event)
    },
    onClickAction() {
      this.$emit('clickAction')
    }
  }
}
</script>